"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _setHotspot = _interopRequireDefault(require("@/views/applet/setting/decorationPage/library/modules/Hotspot/setHotspot"));
var _hotspotUtils = require("@/views/applet/setting/decorationPage/library/modules/Hotspot/hotspotUtils");
var _systemSetting = require("@/api/systemSetting.js");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    SetHotspotVue: _setHotspot.default
  },
  data: function data() {
    return {
      itemInfo: {},
      activeSetting: 1,
      userType: null // 用户类型
    };
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    value: {
      handler: function handler() {
        var _this = this;
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // 确保所有必需的嵌套对象都存在
        var defaultData = {
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 0,
            mr: 0
          }
        };
        // 合并传入的数据和默认数据
        var merged = _objectSpread(_objectSpread(_objectSpread({}, defaultData), val), {}, {
          formMargin: _objectSpread(_objectSpread({}, defaultData.formMargin), val.formMargin || {})
        });
        // 静默修正存量越界热区（旧版按画布显示像素保存的坐标会超出 picW/picH）
        var normalized = (0, _hotspotUtils.normalizeHotspotData)(merged);
        this.itemInfo = normalized.data;
        if (normalized.changed) {
          // normalizeHotspotData 幂等，二次触发 watch 不会再次 emit
          this.$nextTick(function () {
            return _this.updateItem();
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    // 获取用户类型
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
    } catch (e) {
      this.userType = null;
    }
  },
  methods: {
    updateItem: function updateItem() {
      this.$emit("input", this.itemInfo);
    },
    modalPicTap: function modalPicTap(tit, type) {
      var _this2 = this;
      this.$modalUpload(function (img) {
        _this2.$set(_this2.itemInfo, 'bgImg', img[0].sattDir);
        _this2.updateItem();
      }, tit, 'system');
    },
    removeImg: function removeImg(type) {
      if (type == 'pic') {
        this.$set(this.itemInfo, 'pic', '');
      } else if (type == 'bgImg') {
        this.$set(this.itemInfo, 'bgImg', '');
      }
      ;
      this.updateItem();
    },
    // 热区主图上传前的校验（≤450KB）
    beforeHotspotUpload: function beforeHotspotUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var maxSize = 450 * 1024;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (file.size > maxSize) {
        this.$message.error('热区图片大小需小于等于 450KB！');
        return false;
      }
      return true;
    },
    validateHotspotImage: function validateHotspotImage(imageData) {
      var maxSize = 450 * 1024;
      var sizeBytes = this.parseAttachmentSizeBytes(imageData);
      if (sizeBytes != null && sizeBytes > maxSize) {
        this.$message.error('热区图片大小需小于等于 450KB！');
        return false;
      }
      return true;
    },
    parseAttachmentSizeBytes: function parseAttachmentSizeBytes(item) {
      if (!item) return null;
      var raw = item.attSize || item.att_size || item.fileSize || item.size;
      if (raw == null || raw === '') return null;
      if (typeof raw === 'number') {
        return raw > 1024 * 500 ? raw : raw * 1024;
      }
      var str = String(raw).trim();
      var kbMatch = str.match(/^([\d.]+)\s*KB$/i);
      if (kbMatch) return parseFloat(kbMatch[1]) * 1024;
      var mbMatch = str.match(/^([\d.]+)\s*MB$/i);
      if (mbMatch) return parseFloat(mbMatch[1]) * 1024 * 1024;
      var bMatch = str.match(/^([\d.]+)\s*B$/i);
      if (bMatch) return parseFloat(bMatch[1]);
      var num = parseFloat(str);
      if (!isNaN(num)) return num;
      return null;
    },
    // 背景图上传前的校验
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB！');
        return false;
      }
      return true;
    },
    // 处理本地上传
    handleLocalUpload: function () {
      var _handleLocalUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(options, fieldName) {
        var file, formData, params, loading, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = options.file;
              if (!(fieldName === 'pic' && !this.beforeHotspotUpload(file))) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              formData = new FormData();
              formData.append('multipart', file);
              params = {
                model: 'product',
                pid: 1
              };
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context.p = 2;
              _context.n = 3;
              return (0, _systemSetting.fileImageApi)(formData, params);
            case 3:
              res = _context.v;
              loading.close();
              if (res && res.url) {
                this.$set(this.itemInfo, fieldName, res.url);
                this.updateItem();
                if (fieldName === 'pic') {
                  this.setImageNaturalSize(res.url);
                }
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败，请重试');
              }
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              loading.close();
              this.$message.error('上传失败：' + (_t.message || '请重试'));
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4]]);
      }));
      function handleLocalUpload(_x, _x2) {
        return _handleLocalUpload.apply(this, arguments);
      }
      return handleLocalUpload;
    }(),
    setHotspot: function setHotspot() {
      var _this$itemInfo;
      if (!((_this$itemInfo = this.itemInfo) !== null && _this$itemInfo !== void 0 && _this$itemInfo.pic)) {
        this.$message.warning('请先上传图片');
        return;
      }
      ;
      this.$refs.setHotspotVueRef.open(this.itemInfo);
    },
    uploadImg: function uploadImg() {
      var _this3 = this;
      this.$modalUpload(function () {
        var _data$;
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        if (!_this3.validateHotspotImage(data[0])) return;
        var forms = JSON.parse(JSON.stringify(_this3.itemInfo));
        forms["pic"] = data[0].sattDir;
        _this3.itemInfo = forms;
        if (!(data !== null && data !== void 0 && (_data$ = data[0]) !== null && _data$ !== void 0 && _data$.sattDir)) return;
        _this3.setImageNaturalSize(data[0].sattDir);
      }, '1', 'system', false, {
        maxSizeKB: 450,
        maxSizeErrorMsg: '热区图片大小需小于等于 450KB！'
      });
    },
    updateForm: function updateForm(itemInfo) {
      this.itemInfo = _objectSpread(_objectSpread({}, this.itemInfo), itemInfo);
      this.updateItem();
    },
    setImageNaturalSize: function setImageNaturalSize(url) {
      var _this4 = this;
      if (!url) return;
      var image = new Image();
      image.onload = function () {
        _this4.$set(_this4.itemInfo, 'picW', image.naturalWidth || image.width || 0);
        _this4.$set(_this4.itemInfo, 'picH', image.naturalHeight || image.height || 0);
        _this4.updateItem();
      };
      image.onerror = function () {
        console.warn('无法获取图片尺寸', url);
      };
      image.src = url;
    }
  }
};